import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import SetWinningFlag from "./components/SetWinningFlag";
import Budget from "./components/Budget";
import CreateGift from "./components/CreateGift";
import GiftDataPage from "./components/GiftDataPage";

export default function Game() {
    return (
        <TabView>
            <TabPanel header="Set Winning Flag">
                <SetWinningFlag />
            </TabPanel>
            <TabPanel header="Budget">
                <Budget />
            </TabPanel>
            {/* <TabPanel header="Create Gift">
                <CreateGift />
            </TabPanel> */}
            <TabPanel header="Gift Data">
                <GiftDataPage />
            </TabPanel>
        </TabView>
    );
}